// Error codes shared between the server (throw sites) and the client (ErrorPage),
// so the UI can render a friendly, purpose-specific message instead of the generic
// "Connection Failed" copy.

export const ErrorCode = {
  ACCOUNT_ALREADY_CONNECTED: 'ACCOUNT_ALREADY_CONNECTED',
  PLAYER_ALREADY_REGISTERED: 'PLAYER_ALREADY_REGISTERED',
  PURCHASE_THRESHOLD_NOT_MET: 'PURCHASE_THRESHOLD_NOT_MET',
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

/** True when the code marks a duplicate account/player that is already connected. */
export function isDuplicateAccountCode(code: string | undefined): boolean {
  return (
    code === ErrorCode.ACCOUNT_ALREADY_CONNECTED ||
    code === ErrorCode.PLAYER_ALREADY_REGISTERED
  );
}

/** Error that carries a machine-readable code + HTTP status for the API to surface. */
export class AppError extends Error {
  constructor(
    message: string,
    readonly code: ErrorCode,
    readonly status: number = 409
  ) {
    super(message);
    this.name = 'AppError';
  }
}
